import React, { useContext, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, NavbarBrand } from "react-bootstrap";
import { Drawer, List, ListItem, ListItemText, Collapse, ListItemButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";


import "./NavBar.css";
import NavHamburger from "./NavHamburger";
import useScreenSize from './useScreenSize'
import rt from "../../image/rt-brand2.png";
import colorful from '../../image/banner/colorful-paint.png'
import { CartContext } from "../../CartContext";

const NaviBar = () => {
  const [expanded, setExpanded] = useState(false);
  const isMobile = useScreenSize('(max-width: 768px)');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { cart, toggleCart } = useContext(CartContext);
  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  const toggleHamburger = () => {
    setExpanded(!expanded);
  };

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    console.log(
      "E-Com site developed by Julio Daniel using React, HTML, CSS and Javascript. Visit juliodaniel.com for details."
    );
  }, [isMobile]);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!expanded) {
      document.body.style.overflow = "";
      return undefined;
    }

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [expanded]);

  const NavbarLinks = () => (
    <>
      <div className={`navbar-nav ${expanded ? "open" : ""}`}>
        <nav
          className="hoverDiv"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          {/* <h3 className="banner-title">You Are Aᴿᵀ</h3> */}
          <h3 className="banner-title">
            You Are A
            <img src={rt} alt="RT" className="rt-image" />
          </h3>
          <Nav.Link
            data-testid="nav-link1"
            className="nav-link"
            as={Link}
            to="/"
          >
            <div className="nav-button">HOME</div>
          </Nav.Link>
          <div className="nav-link nav-button">
            <a href="merch">
              WEARABLE ART & THANGZ
              {dropdownOpen && (
                <div className="dropdown-content">
                  <Link to="/FlirtyLazuli" className="dropdown-item">
                    Flirty Lazuli Collection
                  </Link>
                  <Link to="/SeleneCollection" className="dropdown-item">
                    Selene Princess Collection
                  </Link>
                  <Link to="/Stickers" className="dropdown-item">
                    Stickers
                  </Link>
                  <Link to="/Purses" className="dropdown-item">
                    Purses
                  </Link>
                </div>
              )}
            </a>
          </div>
          <div className="nav-link nav-button">
            <a href="original-paintings-1">
              ORIGINAL PAINTINGS
              {dropdownOpen && (
                <div className="dropdown-content">
                  <Link to="/GoldCollection" className="dropdown-item">
                    GOLD: INSPIRED BY PABLO PICASSO
                  </Link>
                  <Link to="/QuantumCollection" className="dropdown-item">
                    QUANTUM ENTANGLEMENT
                  </Link>
                  <Link to="/AbstractsCollection" className="dropdown-item">
                    ABSTRACTS
                  </Link>
                  <Link to="/HollywoodCollection" className="dropdown-item">
                    HOLLYWOOD ICONS
                  </Link>
                  <Link to="/NBAAllStars" className="dropdown-item">
                    NBA ALL STARS
                  </Link>
                  <Link to="/FutbolCollection" className="dropdown-item">
                    FUTBOL ICONS
                  </Link>
                  <Link to="/LockdownCollection" className="dropdown-item">
                    LOCKDOWNS MADE ME PAINT THIS
                  </Link>
                  {/* <Link to="/RadicalCollection" className="dropdown-item">
                    FREE RADICALS
                  </Link> */}
                </div>
              )}
            </a>
          </div>
          <div className="nav-link nav-button">
            <a href="/Prints">
              LIMITED EDITION PRINTS
              {dropdownOpen && (
                <div className="dropdown-content">
                  <Link to="/HollywoodPrints" className="dropdown-item">
                    Hollywood Icon Prints
                  </Link>
                  <Link to="/QuantumPrints" className="dropdown-item">
                    Quantum Entanglement Prints
                  </Link>
                </div>
              )}
            </a>
          </div>
          <button
            className="nav-cart-button"
            type="button"
            onClick={toggleCart}
            aria-label={`Open cart with ${cartCount} item${cartCount === 1 ? "" : "s"}`}
          >
            Cart{cartCount > 0 ? ` (${cartCount})` : ""}
          </button>
        </nav>
      </div>
    </>
  );

  const [openDropdown, setOpenDropdown] = useState({});
  const handleDropdownClick = (dropdownName) => {
    setOpenDropdown((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  const DrawerLinks = () => (
    <Drawer
      anchor="right"
      open={expanded}
      onClose={toggleHamburger}
      sx={{ zIndex: 1300 }}
      PaperProps={{ className: "mobile-drawer-paper" }}
      BackdropProps={{ className: "mobile-drawer-backdrop" }}
    >
      <div className="mobile-drawer-shell">
        <div className="mobile-drawer-header">
          <div className="mobile-drawer-heading">
            <p className="mobile-drawer-eyebrow">Browse</p>
            <h2 className="mobile-drawer-title">You Are Art</h2>
          </div>
          <button
            type="button"
            className="mobile-drawer-close"
            onClick={toggleHamburger}
            aria-label="Close menu"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <nav className="mobile-drawer-nav" aria-label="Mobile navigation">
          <List disablePadding>
            <ListItem
              className="mobile-drawer-item"
              component={Link}
              to="/"
              onClick={toggleHamburger}
            >
              <ListItemText primary="Home" />
            </ListItem>

            <ListItemButton
              className="mobile-drawer-item mobile-drawer-item--toggle"
              onClick={() => handleDropdownClick("merch")}
            >
              <ListItemText primary="Wearable Art & Thangz" />
              {openDropdown.merch ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openDropdown.merch} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className="mobile-drawer-sublist">
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/FlirtyLazuli"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Flirty Lazuli Collection" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/SeleneCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Selene Princess Collection" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/Stickers"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Stickers" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/Purses"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Purses" />
                </ListItem>
              </List>
            </Collapse>

            <ListItemButton
              className="mobile-drawer-item mobile-drawer-item--toggle"
              onClick={() => handleDropdownClick("originals")}
            >
              <ListItemText primary="Original Paintings" />
              {openDropdown.originals ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openDropdown.originals} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className="mobile-drawer-sublist">
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/GoldCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Gold: Inspired by Pablo Picasso" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/QuantumCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Quantum Entanglement" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/AbstractsCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Abstracts" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/HollywoodCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Hollywood Icons" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/NBAAllStars"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="NBA All Stars" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/FutbolCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Futbol Icons" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/LockdownCollection"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Lockdowns Made Me Paint This" />
                </ListItem>
              </List>
            </Collapse>

            <ListItemButton
              className="mobile-drawer-item mobile-drawer-item--toggle"
              onClick={() => handleDropdownClick("prints")}
            >
              <ListItemText primary="Prints" />
              {openDropdown.prints ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openDropdown.prints} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className="mobile-drawer-sublist">
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/HollywoodPrints"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Hollywood Icon Prints" />
                </ListItem>
                <ListItem
                  className="mobile-drawer-subitem"
                  component={Link}
                  to="/QuantumPrints"
                  onClick={toggleHamburger}
                >
                  <ListItemText primary="Quantum Entanglement Prints" />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </nav>
      </div>
    </Drawer>
  );



  const mobileHeaderBar = (
    <div className="mobile-navbar">
      <NavbarBrand className="navbar-brand navbar-brand-mobile" as={Link} to="/">
        <img className="navbar-brand-img" src={rt} alt="Reena Tolentino" />
      </NavbarBrand>

      <div className="mobile-navbar-actions">
        <button
          className="mobile-navbar-cart"
          type="button"
          onClick={toggleCart}
          aria-label={`Open cart with ${cartCount} item${cartCount === 1 ? "" : "s"}`}
        >
          Cart{cartCount > 0 ? ` (${cartCount})` : ""}
        </button>
        <NavHamburger toggleHamburger={toggleHamburger} isOpen={expanded} />
      </div>
    </div>
  );

  return (
    <>
      <Navbar className="navbar" expand="lg">
        {isMobile ? (
          <>
            {createPortal(mobileHeaderBar, document.body)}
            <div className="mobile-navbar-spacer" aria-hidden="true" />
            <DrawerLinks />
          </>
        ) : (
          <>
            {isHomePage && (
              <img
                className="banner-img fade-out"
                draggable="false"
                src={colorful}
                alt="banner"
              />
            )}
            <NavbarLinks />
          </>
        )}
      </Navbar>
    </>
  );
};

export default NaviBar;